<template>
  <div>
    <p class="py-2">
      Add all of the timeslots that will be available for your customers to
      pickup this product.
    </p>
    <d-list-group>
      <d-list-group-item v-for="v in value" :key="v.id">
        <d-row>
          <d-col cols="12" md="3">
            <odd-label>Start Time</odd-label>
            <div class="small text-light">{{ formatDate(v.start_time) }}</div>
          </d-col>
          <d-col cols="12" md="3">
            <odd-label>End Time</odd-label>
            <div class="small text-light">{{ formatDate(v.end_time) }}</div>
          </d-col>
          <d-col cols="12" md="3">
            <odd-label>Location Time</odd-label>
            <div class="small text-light">{{ formatLocation(v.location) }}</div>
          </d-col>
          <d-col cols="12" md="3">
            <div
              class="d-flex justify-content-center align-items-center w-100 h-100"
            >
              <d-button theme="danger" @click="handleDeleteLimitedRelease(v.id)"
                >Delete</d-button
              >
            </div>
          </d-col>
        </d-row>
      </d-list-group-item>

      <d-list-group-item class="bg-light">
        <div class="w-100 d-flex flex-row">
          <d-row class="flex-grow-1">
            <d-col cols="12" md="3">
              Start Time
              <datetime v-model="newStart" type="datetime"></datetime>
            </d-col>
            <d-col cols="12" md="3">
              End Time
              <datetime v-model="newEnd" type="datetime"></datetime>
            </d-col>
            <d-col cols="12" md="3">
              Location
              <d-form-select v-model="newLocation" :options="locationOptions" />
            </d-col>
            <d-col cols="12" md="3">
              <div class="p-4 m-auto">
                <d-button size="sm" block @click="handleAddButton"
                  >Add</d-button
                >
              </div>
            </d-col>
          </d-row>
        </div>
      </d-list-group-item>
    </d-list-group>
  </div>
</template>

<script>
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { normalizeISO } from "../../utils/datetime";
import { nanoid } from "nanoid";

const newID = () => {
  return nanoid()
    .substring(0, 6)
    .replace("_", Math.floor(Math.random() * 10));
};

const sample = {
  locations: [
    { id: "123", name: "Farmers Market" },
    { id: "456", name: "The Farm" }
  ],
  dates: ["08_28_2020", "08_29_2020"],
  times: [
    {
      date: "08_28_2020",
      start_time: "11_00",
      end_time: "12_00",
      location: "123"
    },
    {
      date: "08_28_2020",
      start_time: "11_00",
      end_time: "12_00",
      location: "456"
    },
    {
      date: "08_29_2020",
      start_time: "11_00",
      end_time: "12_00",
      location: "456"
    }
  ]
};

export default {
  components: {
    Datetime
  },
  data() {
    return {
      currentValues: sample,
      newStart: null,
      newEnd: null,
      newLocation: null,
      newDate: null,
      newMax: null,
      locationOptions: []
    };
  },
  created() {
    this.$store
      .dispatch("merchants/getLocations", this.merchantID)
      .then(data => {
        const options = [];
        data.forEach(i => {
          options.push({
            value: i.id,
            text: i.name
          });
        });
        this.locationOptions = options;
        if (options.length > 0) {
          this.newLocation = options[0].value;
        }
      });
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    merchantID: {
      type: String,
      default: ""
    }
  },
  watch: {},
  methods: {
    handleDeleteLimitedRelease(id) {
      let valueCopy = JSON.parse(JSON.stringify(this.value));
      this.$emit("input", valueCopy.filter(v => v.id !== id));
    },
    handleInput(val, slug) {
      let updated = JSON.parse(JSON.stringify(this.value));
      updated[slug] = val;
      console.log(updated);
      this.$emit("input", updated);
    },
    formatDate(d) {
      return normalizeISO(d);
    },
    formatLocation(l) {
      const o = this.locationOptions.find(v => v.value === l);
      return o.text;
    },
    handleAddButton() {
      const newPickup = {
        start_time: this.newStart,
        end_time: this.newEnd,
        location: this.newLocation,
        max_orders: this.newMax,
        id: newID()
      };
      const valueCopy = JSON.parse(JSON.stringify(this.value));
      valueCopy.push(newPickup);
      this.$emit("input", valueCopy);
    }
  }
};
</script>

<style lang="scss">
.vdatetime-input {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.3rem + 0.15rem);
  padding: 0.15rem 0.6rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  color: #545963;
  background-color: #fff;
  background-clip: padding-box;
  border: 0.075rem solid #ced4da;
  border-radius: 0.15rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}
</style>
